/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { Button } from "@material-ui/core";
import Page from "components/common_components/Page/Page";
import useStyles from "../useStyles";
import { useDispatch, useSelector } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import ModulesContext from "../ModulesContext";
import { Form as FormikForm, TextField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import RefreshIcon from "@material-ui/icons/Refresh";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import TimelapseIcon from "@material-ui/icons/Timelapse";
import InputAdornment from "@material-ui/core/InputAdornment";
import AccountCircle from "@material-ui/icons/AccountCircle";
import TodayIcon from "@material-ui/icons/Today";
import EventIcon from "@material-ui/icons/Event";
import { taskStatuses } from "utils/static/workflowsStaticData";
import { useWorkflowStyles, getHeadCells } from "./utils";
import EditTaskDialog from "components/Home/Dashboard/EditTaskDialog";
import AppContext from "AppContext";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import AddIcon from "@material-ui/icons/Add";
import AddTaskDialog from "components/Home/Dashboard/AddTaskDialog";

function Workflow({ onCancel }) {
    const classes = useStyles();
    const workflowClasses = useWorkflowStyles();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.Login);
    const [resources, setResources] = useState({ users: [] });

    const {
        currentFileCase,
        workflow: _workflow,
        isLoading,
        getWorkflowAsync,
        restartWorkflowAsync,
        startWorkflowAsync,
    } = useContext(ModulesContext);

    const { tasks, ...workflow } = _workflow || {};

    const [formDialogProps, setFormDialogProps] = useState({
        open: false,
        maxWidth: "lg",
        fullWidth: true,
        title: "",
        formId: undefined,
        task: undefined,
        onSuccessCallback: getWorkflowAsync,
        onClose: () => {
            setFormDialogProps((prev) => ({ ...prev, open: false, formId: undefined, task: undefined }));
        },
    });

    const [addTaskFormDialogProps, setAddTaskFormDialogProps] = useState({
        open: false,
        maxWidth: "md",
        fullWidth: true,
        title: "",
        formId: `in-dialog-form-new-task`,
        onClose: () => {
            setAddTaskFormDialogProps((prev) => ({ ...prev, open: false }));
        },
    });

    const {
        api: {
            Settings: { Users },
        },
    } = useContext(AppContext);

    function getUsers() {
        Users.getAll({
            onSuccess: (data) => {
                setResources((prev) => ({
                    ...prev,
                    users: data,
                }));
            },
            onError: (error) => {
                setResources((prev) => ({
                    ...prev,
                    users: [],
                }));
                dispatch(notifyError(error));
            },
        });
    }

    useEffect(() => {
        getUsers();

        return () =>
            setResources((prev) => ({
                users: [],
            }));
    }, []);

    useEffect(() => {
        if (!currentFileCase) {
            dispatch(notifyError("You have to select a client file first!"));
            onCancel();
        }
    }, [currentFileCase]);

    function isValidUser(task) {
        return task.assigneeUserId === user.id || user.isAdmin || workflow.ownerUserId === user.id;
    }

    function onRowClickHandler(item) {
        if (isValidUser(item)) {
            setFormDialogProps((prev) => ({
                ...prev,
                task: item,
                open: true,
                formId: `in-dialog-form-task_${item && item.id}`,
            }));
        }
    }

    function isValidWorkflowObject() {
        return workflow && Object.keys(workflow).length > 0;
    }

    function onAddTaskClickHandler() {
        setAddTaskFormDialogProps((prev) => ({
            ...prev,
            open: true,
            trnFlowId: isValidWorkflowObject() && workflow.id,
        }));
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Grid container spacing={3} style={{ justifyContent: "space-between" }}>
                        <Grid item md={6}>
                            {!currentFileCase.trnFlowId && !isValidWorkflowObject() ? (
                                <Button
                                    variant="text"
                                    size="small"
                                    color="primary"
                                    startIcon={<PlayCircleFilledWhiteIcon />}
                                    onClick={startWorkflowAsync}>
                                    Start workflow
                                </Button>
                            ) : (
                                <Button
                                    variant="text"
                                    size="small"
                                    color="secondary"
                                    startIcon={<RefreshIcon />}
                                    onClick={() => getWorkflowAsync()}>
                                    Refresh
                                </Button>
                            )}
                        </Grid>

                        {isValidWorkflowObject() && (
                            <Grid item xs={12}>
                                <FormikForm initialValues={workflow} showButtons={false}>
                                    {({ values }) => (
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={3}>
                                                {" "}
                                                <TextField
                                                    fieldName="ownerUserFullName"
                                                    disabled
                                                    label="Owner"
                                                    variant="standard"
                                                    inputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <AccountCircle />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    disabled
                                                    startIcon={
                                                        (taskStatuses.find((x) => x.value === values.status) || {}).icon
                                                    }
                                                    className={workflowClasses[values.status]}>
                                                    {values.statusString}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    fieldName="startDateString"
                                                    disabled
                                                    label="Start Date"
                                                    variant="standard"
                                                    inputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <TodayIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <TextField
                                                    fieldName="endDateString"
                                                    disabled
                                                    label="End Date"
                                                    variant="standard"
                                                    inputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <EventIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={1}>
                                                <TextField
                                                    fieldName="restarts"
                                                    disabled
                                                    label="Restarts"
                                                    variant="standard"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                {values.finished ? (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        disabled
                                                        startIcon={<DoneAllIcon />}
                                                        className={workflowClasses.finishedButton}>
                                                        Finished
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        disabled
                                                        startIcon={<TimelapseIcon />}
                                                        className={workflowClasses.notFinishedButton}>
                                                        Not finished yet
                                                    </Button>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Button
                                                    onClick={onAddTaskClickHandler}
                                                    variant="outlined"
                                                    size="small"
                                                    color="primary"
                                                    startIcon={<AddIcon />}>
                                                    Add new task
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {values &&
                                                    values.allowRestart &&
                                                    values.status !== "closed" &&
                                                    user.isAdmin && (
                                                        <Button
                                                            variant="text"
                                                            size="small"
                                                            color="primary"
                                                            startIcon={<RefreshIcon />}
                                                            onClick={restartWorkflowAsync}>
                                                            Restart workflow
                                                        </Button>
                                                    )}
                                            </Grid>
                                        </Grid>
                                    )}
                                </FormikForm>
                            </Grid>
                        )}
                        {tasks && Array.isArray(tasks) && (
                            <Grid item xs={12}>
                                <EnhancedTable
                                    headCells={getHeadCells(workflowClasses)}
                                    data={tasks.sort((a, b) => a.ordinal - b.ordinal)}
                                    title="Tasks"
                                    keyColumnName="id"
                                    defaultOrder={{ order: "asc", orderBy: "ordinal" }}
                                    selectable={false}
                                    onRowClick={onRowClickHandler}
                                    deletable={false}
                                    filterable={false}
                                    pageable={false}
                                    dense
                                />
                            </Grid>
                        )}
                    </Grid>
                    <EditTaskDialog resources={resources} {...formDialogProps} />
                </>
            )}
            {currentFileCase && currentFileCase.trnFlowId && (
                <AddTaskDialog resources={resources} {...addTaskFormDialogProps} onSuccessCallback={getWorkflowAsync} />
            )}
        </Page>
    );
}

Workflow.propTypes = {
    onCancel: PropTypes.func,
};

Workflow.defaultProps = {
    onCancel: () => {},
};

export default withRouter(Workflow);
